import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Users = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 25 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M8.803 13.166c2.493 0 4.95 1.715 5.885 5.065.19.682 0 1.268-.39 1.703a2.25 2.25 0 0 1-1.64.732H4.949a2.25 2.25 0 0 1-1.64-.732 1.75 1.75 0 0 1-.39-1.703c.934-3.35 3.392-5.065 5.884-5.065m-3.25-5.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.803 6.167a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m-3.25 1.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m7.29 9.623c-.872-2.711-3.036-3.703-4.87-3.278a.75.75 0 0 1-.34-1.461c2.676-.62 5.553.908 6.637 4.28a2.24 2.24 0 0 1-.456 2.189 2.67 2.67 0 0 1-2.011.896h-2a.75.75 0 0 1 0-1.5h2c.367 0 .686-.16.879-.38a.74.74 0 0 0 .16-.746'
          fill='currentColor'
        />
      </>
    ) : (
      <>
        <path
          d='M15.41 18.03c-1.013-3.633-3.736-5.614-6.607-5.614s-5.593 1.98-6.607 5.613c-.53 1.9 1.09 3.387 2.753 3.387h7.709c1.663 0 3.283-1.487 2.753-3.387'
          fill='currentColor'
        />
        <path
          d='M4.803 7.416a4 4 0 1 1 8 0 4 4 0 0 1-8 0'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.803 6.167a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m-3.25 1.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0m7.29 9.623c-.872-2.711-3.036-3.703-4.87-3.278a.75.75 0 0 1-.34-1.461c2.676-.62 5.553.908 6.637 4.28a2.24 2.24 0 0 1-.456 2.189 2.67 2.67 0 0 1-2.011.896h-2a.75.75 0 0 1 0-1.5h2c.367 0 .686-.16.879-.38a.74.74 0 0 0 .16-.746'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
